export default (store) => {
  store.registerModule(['instructions', 'window'], {
    namespaced: true,
    state: {
      open: false,
    },
    getters: {
      isOpen: (state) => state.open,
    },
    mutations: {
      SET_OPEN: (state, val) => {
        state.open = val;
      },
    },
    actions: {
      setOpen({ commit }, val) {
        commit('SET_OPEN', val);
      },
    },
  });
};
